import localforage from "localforage";
import { CredentialsService } from "./CredentialsService.js";

const credentialsMemory = new CredentialsService(localforage);
window.addEventListener("pagehide", () => credentialsMemory.clearMemory());
export default credentialsMemory;
